import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button, Box, IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";
import PropTypes from "prop-types";

const WelcomeModal = ({ open, onSkip, onProceed }) => (
  <Dialog
    open={open}
    maxWidth="md"
    fullWidth
    PaperProps={{
      sx: {
        borderRadius: 3,
        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
      },
    }}
  >
    {/* Close button */}
    <IconButton
      onClick={onSkip}
      sx={{
        position: "absolute",
        right: 8,
        top: 8,
        color: "grey.500",
      }}
      aria-label="close"
    >
      <Close />
    </IconButton>

    {/* Header */}
    <DialogTitle sx={{ pt: 4, pb: 2, px: 4 }}>
      <Box sx={{ textAlign: "center" }}>
        <Typography variant="h3" sx={{ mb: 1, fontSize: "2rem" }}>
          🎉
        </Typography>
        <Typography variant="h4" sx={{ fontWeight: 600, mb: 1 }}>
          Welcome to Nativus Coach!
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 500, mx: "auto" }}>
          We&apos;re excited to have you here. Let&apos;s get you started with a quick tour to help you make the most of
          your coaching platform.
        </Typography>
      </Box>
    </DialogTitle>

    {/* Content */}
    <DialogContent sx={{ px: 4, py: 3 }}>
      {/* Message Section */}
      <Box
        sx={{
          bgcolor: "primary.main",
          color: "white",
          borderRadius: 2,
          p: 3,
          mb: 2,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1, color: "#ffffff" }}>
          What you&apos;ll learn:
        </Typography>
        <Box component="ul" sx={{ m: 0, pl: 2.5, color: "#ffffff" }}>
          <li>
            <Typography variant="body2" sx={{ mb: 0.5, color: "#ffffff" }}>
              Complete your profile and set up your coaching preferences
            </Typography>
          </li>
          <li>
            <Typography variant="body2" sx={{ mb: 0.5, color: "#ffffff" }}>
              Create your first subscription plans and client forms
            </Typography>
          </li>
          <li>
            <Typography variant="body2" sx={{ mb: 0.5, color: "#ffffff" }}>
              Add clients and design custom training programs
            </Typography>
          </li>
          <li>
            <Typography variant="body2" sx={{ color: "#ffffff" }}>
              Set up your calendar and start scheduling sessions
            </Typography>
          </li>
        </Box>
      </Box>

      <Typography variant="body2" color="text.secondary" sx={{ textAlign: "center" }}>
        The guided checklist will walk you through each step. You can skip this tour and explore on your own, or follow
        along for a smooth onboarding experience.
      </Typography>
    </DialogContent>

    {/* Actions */}
    <DialogActions sx={{ px: 4, pb: 4, pt: 2, gap: 2, justifyContent: "center" }}>
      <Button onClick={onSkip} variant="outlined" size="large" sx={{ minWidth: 140, textTransform: "none" }}>
        Skip Tour
      </Button>
      <Button
        onClick={onProceed}
        variant="contained"
        size="large"
        sx={{
          minWidth: 140,
          textTransform: "none",
          bgcolor: "primary.main",
          color: "#ffffff",
          fontWeight: 600,
          "&:hover": {
            bgcolor: "primary.dark",
          },
        }}
      >
        Start Checklist
      </Button>
    </DialogActions>
  </Dialog>
);

WelcomeModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onSkip: PropTypes.func.isRequired,
  onProceed: PropTypes.func.isRequired,
};

export default WelcomeModal;
